import { render, staticRenderFns } from "./PageTopNav.vue?vue&type=template&id=5fb5c877&"
import script from "./PageTopNav.vue?vue&type=script&lang=js&"
export * from "./PageTopNav.vue?vue&type=script&lang=js&"
import style0 from "./PageTopNav.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports